import { gql } from "@apollo/client";

export const Fleets = gql`
query M_sim_list_fleet_dropdown(
  $id: uuid
) {
    aatmsv4_fleets(order_by: {aircraft: asc}, where: {clientsid: {_eq: $id}, active: {_eq: true}}) {
    aircraft
    fleetsid
    } 
}
`

export const getClientId = gql`
query login(
    $id: String
) {
  aatmsv4_users(where: {userid: {_eq: $id}}) {
    client {
      clientname
      clientsid
    }
  }
}
`
export const SimFormQuery = gql`
query M_sim_list(
  $id: uuid
  $fleetid: uuid
  $date: date
  $active: Boolean
) {
  aatmsv4_sims(order_by: {simlocation: asc}, where: {active: {_eq: $active}, clientsid: {_eq: $id}, validity: {_gte: $date}, fleetsid: {_eq: $fleetid}}) {
    fleet {
      aircraft
    }
    simtype
    simlocation
    simreg
    validity
    approval
    sid
  }
}

`
export const insertSims = gql`
mutation MyMutation(
  $clientsid: uuid
  $fleetsid: uuid
  $simlocation: String
  $simreg: String
  $validity: date
  $simtype: String
  $approval: String
) {
  insert_aatmsv4_sims(objects: {active: true, clientsid: $clientsid, fleetsid: $fleetsid, simlocation: $simlocation, simreg: $simreg, validity: $validity, simtype: $simtype, approval: $approval}) {
    returning {
      sid
    }
  }
}

`
export const UpdateSims = gql`
mutation MyMutation(
  $active: Boolean
  $approval: String
  $validity: date
  $sid: uuid
  ) {
  update_aatmsv4_sims(where: {sid: {_eq: $sid}}, _set: {active: $active, approval: $approval, validity: $validity}) {
    returning {
      active
      approval
      sid
      validity
    }
  }
}
`